import { Injectable } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  SignInForm,
  SignInFormConfig,
  SignInFormField,
} from '@checkout/util-models';
import { FormControlValidators } from '@domgen/dgx-fe-forms/shared';
import { TranslateService } from '@domgen/dgx-fe-i18n';
import { FeatureLandingTranslationDictionary } from '../../models/i18n/feature-landing-dictionary.interface';

@Injectable()
export class SignInFormBuilder {
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly translateService: TranslateService<FeatureLandingTranslationDictionary>
  ) {}

  build(config: SignInFormConfig): FormGroup<SignInForm> {
    return this.formBuilder.group(this.buildFormConfig(config));
  }

  private buildFormConfig(config: SignInFormConfig): SignInForm {
    const { initialValue } = config;

    return {
      [SignInFormField.Email]: new FormControl(
        initialValue?.email ?? null,
        Validators.compose([
          FormControlValidators.required(
            this.translateService.translate(
              'SIGN_IN_FORM_EMAIL_ADDRESS_ERROR_REQUIRED'
            )
          ),
          FormControlValidators.email(
            this.translateService.translate(
              'SIGN_IN_FORM_EMAIL_ADDRESS_ERROR_EMAIL'
            )
          ),
          FormControlValidators.maximumLength(
            50,
            this.translateService.translate(
              'SIGN_IN_FORM_EMAIL_ADDRESS_ERROR_MAX_LENGTH',
              { maxLength: 50 }
            )
          ),
        ])
      ),
      [SignInFormField.Password]: new FormControl(
        initialValue?.password ?? null,
        Validators.compose([
          FormControlValidators.required(
            this.translateService.translate(
              'SIGN_IN_FORM_PASSWORD_ERROR_REQUIRED'
            )
          ),
        ])
      ),
    };
  }
}
